<template>
  <v-container
        fluid class="login-container">
    <v-app-bar
          class="custom-app-bar"
          app>
            <v-toolbar-title class="align-left">
              <img src="~@/assets/csg-transformed.png" style="width:50%; " alt="logo">
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              Dropdown Menu
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="item in menuItems" :key="item.title"
            @click="handleMenuItemClick(item)">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
     </v-app-bar>
     <v-container fluid fill-height>
      <v-row no-gutters justify="center" align="center" class="h-100">
        <v-col cols="4">
          <v-card
            class="pa-2 card-buttons"
            tile
            name="cancel"
          :color="'transparent'"
            v-on:click="handleCardClick('cancel')"
            flat
          >
          <v-card-text><span class="primaryLogo">CS</span>
            <span class="secondaryLogo">Cancel</span></v-card-text>
          </v-card>
        </v-col>

        <v-col cols="4" order="12" >
          <v-card
            class="pa-2 card-buttons"
            tile
            :color="'transparent'"
            name="archive"
            v-on:click="handleCardClick('archive')"
            flat
          >
          <v-card-text><span class="primaryLogo">CS</span>
            <span class="secondaryLogo">Archive</span></v-card-text>
          </v-card>
        </v-col>
        <v-col cols="1" order="1"><div class="border"></div></v-col>
      </v-row>
      <!-- <v-dialog v-model="acceptedterms" persistent max-width="900px"> -->
        <v-dialog persistent max-width="900px">
          <v-card  flat class="fixed-card d-flex flex-column">
            <div>
            </div>
                <v-toolbar dense dark fixed class="sticky-toolbar">
                <v-card-title>
                  Terms & Conditions
                </v-card-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="firstPage()">
                    <v-icon>&lt;&lt;</v-icon>
                  </v-btn>
                  <v-btn icon @click="prevPage(page)">
                    <v-icon> &lt; </v-icon>
                  </v-btn>
                  <span>{{ page }}</span>
                  <v-btn icon @click="changePage(page)">
                    <v-icon>></v-icon>
                  </v-btn>
                  <v-btn icon @click="endPage()">
                    <v-icon>>></v-icon>
                  </v-btn>
                </v-toolbar>
                <pdf
                  v-bind:src="pdfSrc"
                  :page=page
                  style="width: 100%"
                  @num-pages="numPages = $event"
                ></pdf>        
                
                <div class="flex-grow-1"></div> <!-- This pushes the content below it to the bottom -->

                <v-card-actions class="d-flex align-center">
                  <p style="color: rgb(0, 0, 0);">Version 1.4</p>
                  <p style="color:rgb(0, 0, 0);">|</p>
                  <p style="color:rgb(0, 0, 0);">May 22, 2022</p>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="declinedTerms()">Decline</v-btn>
                  <v-btn color="black darken-1" text @click="acceptedTerms()">Accept</v-btn>
                </v-card-actions>
              </v-card>
        </v-dialog>
  </v-container>

  <view-footer></view-footer>
</v-container>
</template>

<script>
import { Auth } from 'aws-amplify';
import { mapState, mapGetters } from 'vuex';
import pdf from 'vue-pdf';
import axios from 'axios';
import ViewFooter from '../components/templates/ViewFooter.vue';
export default {
  components: {
    pdf,
    ViewFooter
  },
  data: () => ({
    drawer: false,
    company: '',
    menuItems: [
      { title: 'CSConnect' },
      { title: 'CSArchive' },
      { title: 'CSCancel' },
      { title: 'Sign Out' },
      { title: 'Contact Support' }, 
    ],
    acceptedterms: true,
    pdfSrc:'',
    loadedRatio: 0,
    page: 1,
    numPages: 0,
    rotate: 0,
  }),
  mounted() {
    this.getAttributes();
    // const groups = this.user.signInUserSession.accessToken.payload['cognito:groups'] || [];
    // eslint-disable-next-line
    // this.company = groups[0];
  },
  methods: {
    acceptedTerms() {
      this.acceptedterms = true
      this.user.updateAttributes([{Name: 'custom:acceptedTerms', Value:'1'}],(err,result)=>{
        if (err) {
        console.log(err);
        return;
      }
        console.log(result);
      })
    },
    declinedTerms() {
      this.acceptedterms = false
      this.logOut()
    },
    changePage(curPage) {
      if (curPage === this.numPages) this.page = curPage;
      else this.page = curPage + 1;
    },
    prevPage(curPage) {
      if (curPage === 1) this.page = curPage;
      else this.page = curPage - 1;
    },
    firstPage() {
      this.page = 1;
    },
    endPage() {
      this.page = this.numPages;
    },
    async logOut() {
      Auth.signOut();
      this.$store.commit('setAuthentication', false);
      this.$router.push('/');
    },
    async getAttributes() {
      let user = await Auth.currentAuthenticatedUser();
      this.company = user.attributes['custom:companyName'];
      console.log(typeof user.attributes['custom:acceptedTerms']);
      this.acceptedterms = true
      // if(user.attributes['custom:acceptedTerms'] !== '1' || user.attributes['custom:acceptedTerms'] === null) {
      //  await this.getPDF()
      //  this.acceptedterms = true
      // }
      if(this.company ==='Homesite') this.$router.push('/cscancel')
      if(this.company ==='MASV'||this.company ==='Augusta'||this.company ==='Northern Neck') this.$router.push('/csarchive')
    
    },
    async getPDF() {
      const data = JSON.stringify(
        {
          company: this.strCompanyName,
          fileName: 'CSDocs Terms of Use.pdf',
        },
      );
      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_GETPDF_URL,
        headers: {
          'x-api-key': process.env.VUE_APP_API_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      try {
        const response = await axios(config);
        this.pdfSrc = response.data;
      } catch(e) {
        console.log(e)
      }
    },
    handleMenuItemClick(item) {
      // Handle the menu item click event

      switch (item.title) {
        case 'Sign Out':
          this.logOut();
          break;
        case 'CSConnect':

          window.open(`https://mpconnect.csgsupport.com/CIS/login/${this.company}`, '_blank');
          break;
        case 'CSArchive':
          this.$router.push('/csarchive');
          break;
        case 'CSCancel':
          this.$router.push('/cscancel');
          break;
        case 'Contact Support':
          this.$router.push('/help');
          break;
        default:

          break;
      }
    },
    handleCardClick(attribute) {
      // Handle the card click event
      let route = '';
      if (attribute === 'cancel') route = 'cscancel';
      else if (attribute === 'archive') route = 'csarchive';
      this.$router.push(`/${route}`);
    },
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['getUser']),
    user() {
      return this.getUser;
    },

  },
};
</script>
<style>
.custom-app-bar {
 background-color: white;
}
.align-left {
 text-align: left;
}
.align-right {
 text-align: right;
}
.align-center {
 align-items: center;
}
.small-font{
 font-size: 10px;
}

.row.align-center {
 align-items: center;
}

.v-slider__thumb{
  cursor:pointer;
}
full-height {
  height: 100vh;
}

.full-width {
  width: 100%;
}

.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.h-100 {
  height: 50vh;
}
.card-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 300px;
  background-color: rgba(246, 244, 244, 0);
}
.centered-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Set the desired height for the card */
}

.centered-text {
  text-align: center;
}
.primaryLogo {
    font-style: italic;
    color: white;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
}

.secondaryLogo {
    font-style: italic;
    color: white;
    font-weight: 1000;
    font-family: Arial, Helvetica, sans-serif;
}

.login-container {
   background-image: url("~@/assets/background.png"); /* Replace with the path to your PNG image */
   background-size: cover;
   background-position: center;
   min-height: 100vh;
 }
 .border {
  width: 3px;
  height: 350px;
  margin: 60px 60px;
  background-color: #ffffff;
}
@media screen and (max-width: 599px) {
    .card-buttons {
      height: 200px; /* Adjust the height for smaller screens */
    }
    .border {
      width: 1px; /* Adjust the width for smaller screens */
      height: 200px; /* Adjust the height for smaller screens */
      margin: 30px 30px; /* Adjust the margins for smaller screens */
    }
    .primaryLogo {
    font-style: italic;
    color: white;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16pt;
    }

    .secondaryLogo {
        font-style: italic;
        color: white;
        font-weight: 1000;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 16pt;
    }
  }

  /* Custom styles for medium-sized screens */
  @media screen and (min-width: 600px) and (max-width: 959px) {
    .card-buttons {
      height: 250px; /* Adjust the height for medium-sized screens */
    }
    .border {
      width: 2px; /* Adjust the width for medium-sized screens */
      height: 250px; /* Adjust the height for medium-sized screens */
      margin: 40px 40px; /* Adjust the margins for medium-sized screens */
    }
    .primaryLogo {
    font-style: italic;
    color: white;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 22pt;
    }

    .secondaryLogo {
        font-style: italic;
        color: white;
        font-weight: 1000;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 22pt;
    }
  }

  /* Custom styles for larger screens */
  @media screen and (min-width: 960px) {
    .card-buttons {
      height: 300px; /* Adjust the height for larger screens */
    }
    .border {
      width: 3px; /* Adjust the width for larger screens */
      height: 300px; /* Adjust the height for larger screens */
      margin: 50px 60px; /* Adjust the margins for larger screens */
    }
    .primaryLogo {
    font-style: italic;
    color: white;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 40pt;
    }

    .secondaryLogo {
        font-style: italic;
        color: white;
        font-weight: 1000;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 40pt;
    }
  }
  .card-container {
  width: 100%;
  max-width: 600px; /* or whatever maximum width you want */
  margin: 0 auto;
}

.fixed-card {
  height: 800px; /* or adjust based on your needs */
  overflow-y: auto;
}

.sticky-toolbar {
  position: sticky;
  top: 0;
  z-index: 2;  /* Ensure it's above the content */
}
</style>
